export const withBenefit = (price = 0) => price * 0.5